import React, { useState } from "react";
import { Accordion, Segment, Icon } from "semantic-ui-react";
import useInspectionPreviousInspections from "../../../hooks/inspections/useInspectionPreviousInspections";
import InspectionSummaryComment from "./InspectionSummaryComment";

export interface StaffPreviousInspectionSummaryProps {
  id: string | number;
}
export default function StaffPreviousInspectionSummary({ id }: StaffPreviousInspectionSummaryProps) {
  const { data, isLoading } = useInspectionPreviousInspections({ id });
  const previousInspections = data?.data ?? [];

  const [open, setOpen] = useState(false);

  if (previousInspections.length === 0) {
    return <></>;
  }

  return (
    <Accordion className='tw-mb-6'>
      <Accordion.Title className='tw-p-0' active={open} onClick={() => setOpen(!open)}>
        <Segment className='tw-border-none'>
          <Icon name='dropdown' />
          Previous Inspection Summary
        </Segment>
      </Accordion.Title>
      <Accordion.Content className='tw-p-0' active={open}>
        <Segment loading={isLoading} className='tw-border-none tw-pt-0'>
          {previousInspections.map((previousInspection) => {
            const comment = previousInspection.attributes.comment ?? "";
            const completedAt = previousInspection.attributes.completedAt ?? "";
            const inspectorFirstName =
              previousInspection.attributes.assignee?.["data"]?.["attributes"]?.["first-name"] ?? "";
            const inspectorLastName =
              previousInspection.attributes.assignee?.["data"]?.["attributes"]?.["last-name"] ?? "";
            return (
              <div key={previousInspection.id} className='tw-py-1'>
                <InspectionSummaryComment
                  key={previousInspection.id}
                  comment={comment}
                  completedAt={completedAt}
                  firstName={inspectorFirstName}
                  lastName={inspectorLastName}
                />
              </div>
            );
          })}
        </Segment>
      </Accordion.Content>
    </Accordion>
  );
}
